import { WithStringValues } from "common/utils/types";

import {
  ProductDealsSearch,
  ProductSearchSearch,
  BrowseSearch,
  ProductListSearch,
  ProductLineAvailabilitySearch,
  ItemPricingSearch,
} from "../types";

export const urls = {
  productSearch: () => "/api/client/v1/search/products/",
  productDealsSearch: () => "/api/client/v1/search/products/deals/",
  productLine: (id: number) => `/api/client/v1/catalog/product-lines/${id}/`,
  product: (id: number) => `/api/client/v1/catalog/products/${id}/`,
  browse: () => "/api/client/v1/search/browse/",
  carousels: () => "/api/client/v1/search/carousels/",
  recentlyViewedProductLines: () => "/api/client/v1/search/recently-viewed-product-lines/",
  category: (id: number) => `/api/client/v1/search/categories/${id}/`,
  categoryProducts: (id: number) => `/api/client/v1/search/categories/${id}/products/`,
  incentive: (id: number) => `/api/client/v1/promotions/incentives/${id}/`,
  incentiveProducts: (id: number) => `/api/client/v1/promotions/incentives/${id}/products/`,
  rebate: (id: number) => `/api/client/v1/promotions/rebates/${id}/`,
  rebateProducts: (id: number) => `/api/client/v1/promotions/rebates/${id}/products/`,
  productLineAvailability: (id: number) =>
    `/api/client/v1/catalog/product-lines/${id}/availability/`,
  itemAddToCartPricing: (id: number) => `/api/client/v1/catalog/items/${id}/pricing/add-to-cart/`,
};

export const keys = {
  all: () => ["products-all"],
  // search
  search: () => [...keys.all(), "search"],
  browse: () => [...keys.search(), "browse"],
  browseFilter: (search: WithStringValues<BrowseSearch>) => [...keys.browse(), search],
  carousels: () => [...keys.search(), "carousels"],
  carouselsFilter: (search: WithStringValues<BrowseSearch>) => [...keys.carousels(), search],
  productSearches: () => [...keys.search(), "products"],
  productSearch: (search: WithStringValues<ProductSearchSearch>) => [
    ...keys.productSearches(),
    search,
  ],
  productDealsSearches: () => [...keys.search(), "product-deals"],
  productDealsSearch: (search: WithStringValues<ProductDealsSearch>) => [
    ...keys.productDealsSearches(),
    search,
  ],

  // categories
  categories: () => [...keys.search(), "categories"],
  categoryDetails: () => [...keys.categories(), "detail"],
  categoryDetail: (id: number) => [...keys.categories(), id],
  categoryProducts: () => [...keys.categories(), "products"],
  categoryProductList: (id: number, search: WithStringValues<ProductListSearch>) => [
    ...keys.categoryProducts(),
    id,
    search,
  ],

  // product lines
  productLines: () => [...keys.all(), "product-lines"],
  productLineDetails: () => [...keys.productLines(), "detail"],
  productLineDetail: (id: number) => [...keys.productLineDetails(), id],
  productLineAvailabilities: () => [...keys.productLines(), "availabilities"],
  productLineDetailAvailability: (
    id: number,
    search: WithStringValues<ProductLineAvailabilitySearch>,
  ) => [...keys.productLineAvailabilities(), id, search],

  // products
  products: () => [...keys.all(), "products"],
  productDetails: () => [...keys.products(), "detail"],
  productDetail: (id: number) => [...keys.productDetails(), id],

  // item add-to-cart pricing
  itemPrices: (id: number, params: ItemPricingSearch) => [
    ...keys.all(),
    "add-to-cart-prices",
    id,
    params,
  ],

  // state
  state: () => [...keys.all(), "state"],

  // incentives
  incentives: () => [...keys.all(), "incentives"],
  incentiveDetails: () => [...keys.incentives(), "detail"],
  incentiveDetail: (id: number) => [...keys.incentiveDetails(), id],
  incentiveProducts: () => [...keys.incentives(), "products"],
  incentiveProductLists: () => [...keys.incentiveProducts(), "list"],
  incentiveProductList: (id: number, search: ProductListSearch) => [
    ...keys.incentiveProductLists(),
    id,
    search,
  ],

  // rebates
  rebates: () => [...keys.all(), "rebates"],
  rebateDetails: () => [...keys.rebates(), "detail"],
  rebateDetail: (id: number) => [...keys.rebateDetails(), id],
  rebateProducts: () => [...keys.rebates(), "products"],
  rebateProductLists: () => [...keys.rebateProducts(), "list"],
  rebateProductList: (id: number, search: ProductListSearch) => [
    ...keys.rebateProductLists(),
    id,
    search,
  ],
};
